import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { Link } from "./Link.js";
export function FileLink({ children, className, as, icon: Icon, ...rest }) {
    const Component = as ?? Link;
    return (_jsxs(Component, { ...rest, className: classNames(className, "cvr-link--file"), children: [_jsx(Icon, {}), children] }));
}
